import {CSVExporter, Exporter, PDFExporter, XLSXExporter} from '../export/export';
import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-expandible-title',
  template: `
    <div class="row top-title">
      <div class="col-sm-12 col-md-12 col-xl-6">
        <p class="text-uppercase title pt-1 title-main" [className]="paragraphClass">{{title}}</p>
      </div>
      <div class="col-sm-11 col-md-11 col-xl-5">
        <p class="label-maps text-right align-middle">{{description}}</p>
      </div>
      <div class="btn-group flex-column flex-wrap align-self-center" *ngIf="exportable">
        <button mat-raised-button
          [matMenuTriggerFor]="menuExportar"
          [disabled]="disabled">
          Exportar<span class="caret"></span>
        </button>
        <mat-menu #menuExportar="matMenu">
          <button mat-menu-item (click)="onPDFExport.emit(PDFExporter)">
            <i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF
          </button>
          <button mat-menu-item (click)="onXLSXExport.emit(XLSXExporter)">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel
          </button>
          <button *ngIf="exportCsv" mat-menu-item (click)="onXLSXExport.emit(CSVExporter)">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> Csv
          </button>
        </mat-menu>
      </div>
      <div class="col-1 text-right" *ngIf="expandible">
        <button type="button" class="btn btn-default" (click)="isClosed = !isClosed" title="Expandir"
                [attr.aria-expanded]="!isClosed"><i [className]="isClosed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'">
        </i></button>
      </div>
    </div>
    <hr>
    <div [isAnimated]="true" [collapse]="isClosed">
      <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
    </div>    `,
})
export class ExpandibleTitleComponent implements OnInit {
  firstClosed = false;
  @Input() title = 'Put your title here !';
  @Input() paragraphClass = 'h2';
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() isClosed     = false;
  @Input() expandible   = true;
  @Input() exportable   = false;
  @Input() disabled     = false;
  @Input() exportCsv    = true;
  @Input() description  = '';
  @Output() onPDFExport: EventEmitter<any> = new EventEmitter<any>();
  @Output() onXLSXExport: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCSVExport: EventEmitter<any> = new EventEmitter<any>();

  PDFExporter: Exporter = new PDFExporter();
  CSVExporter: Exporter = new CSVExporter();
  XLSXExporter: Exporter = new XLSXExporter();

  constructor() {
  }

  ngOnInit() {
    if (this.isClosed && !this.firstClosed) {
      this.isClosed = false;
      setTimeout(() => {
        this.isClosed = true;
        this.firstClosed = true;
      }, 400);
    }
  }

}
